module.exports = __webpack_public_path__ + "static/img/short23.eb9005c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/short23.png
// module id = sCAi
// module chunks = 0